import React, { useEffect, useState } from "react";
import ShowAllStyles from "./ShowAll.styles";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Paper,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification
} from "../../../../helpers/methods";
import CustomInput from "../../../../global/components/CustomInput/CustomInput";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";
import { changeStatusApi, getProjectDetails, getProjectIdDetail, reorder, savePopUpdata } from "./ShowAllService";
import { cacheProjectForEdit } from "../../projectEditCache";
import notifiers from "../../../../global/constants/NotificationConstants";
import CustomLoader from "../../../../global/components/CustomLoader/CustomLoader";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import CustomRadioButton from "../../../../global/components/CustomRadioButton/CustomRadioButton";
import customErrorHandler from "../../../../utils/customErrorHandler";
import AddLoan from "../AddLoan/AddLoan";
import { selectUserId, selectActiveOrganizationId } from "../../../../redux/authSlice";
import EditIcon from '@mui/icons-material/Edit';
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { ReactComponent as VerticalDotIcon } from "../../../../assets/icons/verticalDot.svg";
import { useAppSelector } from "../../../../utils/hooks";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  getAllTeamDataProject,
  getAllTeamMembersDataProject,
} from "../stepper/Personal Details/PersonalDetailsService";
import LongMenu from "./ItemMenu";
import UpdatePricingModal from "./UpdatePricingModal";
import { store } from "../../../../utils/store";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import customTableStyles from "../../../../global/components/CustomTable/customTable.styles";
import { applyLicenseKey } from "../../../../utils/License";
import YhTable, { YhTableColumn, YhTableCellParams } from "../../../../ui/YhTable";
import YhInput from "../../../../ui/YhInput";
import YhModal from "../../../../ui/YhModal";
import YhSelect from "../../../../ui/YhSelect";
import {
  OrgNameCell,
  useOrgNameMap,
} from "../../../../Shared/Organization/OrganizationSelect";
import YhButton from "../../../../ui/YhButton";
import MetaListStyles from "../../../MetaData/components/MetaList/MetaList.styles";
import urls from "../../../../global/constants/UrlConstants";
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const SearchSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21l-4.35-4.35" />
  </svg>
);

const ShowAll = (props: any) => {
  const classes = ShowAllStyles;
  const history = useHistory();
  const privileges = store.getState().auth?.privileges || {};
  const userIdFromRedux: any = useAppSelector(selectUserId);
  const activeOrganizationId = useSelector(selectActiveOrganizationId) || "";
  const orgNameMap = useOrgNameMap();
  const [search, setSearch] = useState<string>("");
  const [debouncedSearch, setDebouncedSearch] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [userDataSource, setUserDataSource] = useState<any>([]);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [menuPosition, setMenuPosition] = useState<{ top: number; left: number } | null>(null);
  const [selectedRow, setSelectedRow] = useState<null | any>(null);
  const [pricingTarget, setPricingTarget] = useState<{
    id: string;
    name: string;
  } | null>(null);
  const [addNewTeamDialog, setNewTeamDialog] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = React.useState(0);
  const userPerPage = 10;
  const pageVisited = pageNumber * userPerPage;
  const customTableClasses = customTableStyles;
  const [userId, setUserId] = useState("");
  const [idd, setIdd] = useState("");
  const [dataForEdit, setDataForEdit] = useState<any>();
  const [status, setStatus] = useState("");
  const [apiResponse, setApiResponse] = useState(false);
  const [selectedUser, setSelectedUser] = useState({ id: "", status: 0 });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpenLoan, setIsDialogOpenLoan] = useState<any>(false);
  const [open, setOpen] = React.useState(false);
  const [leadOption, setLeadOption] = useState<any>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [leadOptionMembers, setLeadOptionMembersas] = useState<any>([]);
  const [selectedOptionsMembers, setSelectedOptionsMembers] = useState<any>([]);
  const [openView, setOpenView] = React.useState("");
  const [openUrl, setOpenUrl] = React.useState("");
  const [projectPopUp, setProjectPopUp] = React.useState({ open: false, data: [], project_id: null });
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [metaData, setMetaData] = useState<any>({});
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 25,
    page: 0,
  });
  const [openModal, setOpenModal] = useState<any>({
    name: "",
    data: {},
    open: false,
  });
  const [rows, setRows] = useState(userDataSource);

  const handleClose = () => setOpen(false);
  const handleProjectIdClose = () => setProjectPopUp({ open: false, data: [], project_id: null });
  useEffect(() => {
    const t = window.setTimeout(() => setDebouncedSearch(search), 350);
    return () => window.clearTimeout(t);
  }, [search]);

  useEffect(() => {
    tableDataShowHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.type, paginationModel, debouncedSearch, activeOrganizationId]);

  useEffect(() => {
    applyLicenseKey();
  }, []);

  // useEffect(() => {
  //   tableDataShowHandler();
  // }, [paginationModel]);
  // useEffect(() => {
  //   tableDataShowHandler();
  // }, [search]);

  const handleChange = (value: any) => {
    setPaginationModel({
      ...paginationModel,
      pageSize: value.target.value,
      page: 0,
    });
  };

  const onClickHandler = () => {
    history.push(urls.CREATEPROJECT);
  };

  const handleEdit = (id: string, data: any) => {
    const projectData = data || null;
    if (id && projectData) cacheProjectForEdit(id, projectData);
    history.push(`${urls.CREATEPROJECT}/${id}`, { projectData });
  };

  const handleCloseLoan = () => {
    setIsDialogOpenLoan(false);
  };

  const changeStatus = async (status: any, id: any) => {
    try {
      const response = await changeStatusApi(status, id);

      customErrorHandler(response);
      openSuccessNotification(response.message);
      setIsDialogOpen(false);
      tableDataShowHandler();
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handelIdButtonSave = async (data: any) => {
    try {
      const response = await savePopUpdata(data);
      customErrorHandler(response);
      openSuccessNotification(response.message);
      setProjectPopUp({
        open: false,
        data: [],
        project_id: null,
      });
      tableDataShowHandler();
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handelIdButton = async (_status: any, id: any) => {
    try {
      const response = await getProjectIdDetail(id);
      setProjectPopUp({
        open: true,
        data: response?.data || [],
        project_id: id,
      });
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handelDropdownAfterSelectEdit = async (ids: any, value: any) => {
    try {
      const payload = {
        team_id: ids,
        project_id: value.projectId,
      };
      const response1 = await getAllTeamMembersDataProject(payload);
      setLeadOptionMembersas(
        response1.data.flatMap((member: any) => {
          return member?.team_members?.map((mem: any) => {
            return {
              pId: member._id,
              id: mem.users[0]._id,
              label: mem.users[0]?.name,
              selected: mem?.is_available,
            };
          });
        })
      );

      setSelectedOptionsMembers(
        response1.data
          .flatMap((member: any) => {
            return member?.team_members?.map((mem: any) => {
              return {
                pId: member._id,
                id: mem.users[0]._id,
                label: mem.users[0]?.name,
                selected: mem?.is_available,
              };
            });
          })
          .filter((item: any) => item.selected === 1)
      );
    } catch { }
  };
  const fetchAssignDetails = async (value: any) => {
    try {
      const response1 = await getAllTeamDataProject(value.projectId);
      // setLeadOption(
      //   response1.data.map((e: any) => {
      //     return {
      //       id: e._id,
      //       label: e.team_name,
      //       selected: e?.is_available,
      //       teamMembers: e.team_members.length
      //         ? e.team_members.map((member: any) => {
      //           return {
      //             id: member.userId,
      //             label: member.users[0].name,
      //             selected: 0,
      //           };
      //         })
      //         : null,
      //     };
      //   })
      // );
      // setSelectedOptions(
      //   response1.data
      //     .filter((e: any) => e?.is_available === 1)
      //     .map((e: any) => {
      //       return {
      //         id: e._id,
      //         label: e.team_name,
      //         selected: e?.is_available,
      //         teamMembers: e.team_members.length
      //           ? e.team_members.map((member: any) => {
      //             return {
      //               id: member.userId,
      //               label: member.users[0].name,
      //               selected: 0,
      //             };
      //           })
      //           : null,
      //       };
      //     })
      // );
      const assignToData = response1.data.flatMap((team: any) => {
        const subTeams = team.sub_teams?.map((subTeam: any) =>

        ({

          id: subTeam._id,
          label: subTeam.team_name,
          selected: subTeam?.is_available,
          isParent: false,
          teamMembers: subTeam.team_members.length
            ? subTeam.team_members.map((member: any) => {
              return {
                id: member.userId,
                label: member.users[0].name,
                selected: 0,
              };
            })
            : null,

        })) || [];

        const mainTeam = {
          id: team._id,
          label: team.team_name,
          selected: team?.is_available,
          isParent: true,
          teamMembers: team.team_members.length

            ? team.team_members.map((member: any) => {
              return {
                id: member.userId,
                label: member.users[0].name,
                selected: 0,
              };
            })
            : null,
        };
        return [mainTeam, ...subTeams];
      })
      setLeadOption(
        assignToData
      );

      const selectedData = assignToData
        .filter((e: any) => {
          return e?.selected === 0;
        })
        .map((e: any) => {
          console.log(e, "Processing in map");
          return {
            id: e.id,
            label: e.label,
            selected: e?.selected,
            teamMembers: Array.isArray(e.teamMembers)
              ? e.teamMembers.map((member: any) => ({
                id: member.id,
                label: member.label,
                selected: 0,
              }))
              : null,
          };
        });

      setSelectedOptions(
        selectedData
      );
      // const ids = response1.data
      //   .filter((e: any) => e?.is_available === 1)
      //   .map((e: any) => e._id);
      // if (ids) {
      //   handelDropdownAfterSelectEdit(ids, value);
      // }
      console.log(assignToData, "assignToDataassignToData")
      const ids = assignToData
        .filter((e: any) => e?.selected === 0)
        .map((e: any) => e.id);
      if (ids) {
        handelDropdownAfterSelectEdit(ids, value);
      }
      setOpen(true);
      setOpenView("");
    } catch { }
  };

  const renderMenu = () => (
    <Menu
      open={Boolean(menuPosition)}
      onClose={() => {
        setMenuPosition(null);
        setSelectedRow(null);
      }}
      anchorReference="anchorPosition"
      anchorPosition={menuPosition ? { top: menuPosition.top, left: menuPosition.left - 190 } : undefined}
      PaperProps={{ sx: { width: 220, maxWidth: '100%' } }}
      sx={MetaListStyles.menuItem}
    >
      <MenuItem style={{ cursor: "default" }}>
        <ListItemText>Actions</ListItemText>
      </MenuItem>
      <MenuItem
        onClick={() => {
          const projectId =
            selectedRow?.data?._id || selectedRow?._id;
          const projectData = selectedRow?.data || selectedRow;
          setMenuPosition(null);
          if (projectId) {
            cacheProjectForEdit(String(projectId), projectData);
            history.push(`${urls.CREATEPROJECT}/${projectId}`, {
              projectData,
            });
          }
        }}
      >
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>

        <ListItemText>Edit</ListItemText>

      </MenuItem>
      <MenuItem
        onClick={() => {
          const projectId =
            selectedRow?.data?._id || selectedRow?._id;
          const projectData = selectedRow?.data || selectedRow;
          setMenuPosition(null);
          if (projectId) {
            setPricingTarget({
              id: String(projectId),
              name: String(
                projectData?.project_name ||
                  projectData?.projectName ||
                  "Project"
              ),
            });
          }
        }}
      >
        <ListItemIcon>
          <CurrencyRupeeIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Update Pricing</ListItemText>
      </MenuItem>
      <MenuItem
        onClick={() => {
          const link =
            selectedRow?.data?.slug ||
            selectedRow?.data?.project_name ||
            selectedRow?.project_name ||
            "";
          setMenuPosition(null);
          if (link) handleWhatsAppShare(String(link));
        }}
      >
        <ListItemIcon>
          <WhatsAppIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Share</ListItemText>
      </MenuItem>
    </Menu>
  );

  const columns: YhTableColumn[] = [
    {
      headerName: "S.No.",
      field: "sno",
      minWidth: 50,
      flex: 1,
      renderCell: (params: YhTableCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <>
            <Typography sx={classes.subHeaderName}>{params.row.sno}</Typography>
          </>
        </Stack>
      ),
    },
    {
      headerName: "Project Name",
      field: "project_name",
      minWidth: 240,
      flex: 1.2,
      renderCell: (params: YhTableCellParams) => {
        const row = params.row || {};
        const data = row.data || {};
        const developerName =
          data.developer_name || row.developer_name || "-";
        const projectName = data.project_name || row.project_name || "-";
        const projectUid = data.project_uid || row.project_uid || "";

        return (
          <div className="py-0.5">
            <p className="text-sm font-bold leading-snug text-[#111827]">
              {developerName}
            </p>
            <p className="mt-0.5 text-sm leading-snug text-[#111827]">
              {projectName}
            </p>
            {projectUid ? (
              <p className="mt-0.5 text-sm leading-snug text-[#374151]">
                {projectUid}
              </p>
            ) : null}
          </div>
        );
      },
    },
    {
      headerName: "Organization",
      field: "organizationId",
      minWidth: 150,
      flex: 0.8,
      renderCell: (params: YhTableCellParams) => {
        const row = params.row || {};
        const data = row.data || {};
        const oid = data.organizationId || row.organizationId;
        return (
          <OrgNameCell
            organizationId={oid}
            map={orgNameMap}
            fallbackLabel={
              data.organizationName ||
              row.organizationName ||
              data.organization?.name
            }
          />
        );
      },
    },
    {
      headerName: "Location",
      field: "location",
      minWidth: 221,
      flex: 1,
      renderCell: (params: YhTableCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography sx={classes.subHeaderName}>{params.row.location}</Typography>
        </Stack>
      ),
    },

    {
      headerName: "Property Type",
      field: "propertyPurpose",
      minWidth: 180,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const row = params.row || {};
        const data = row.data || {};
        const typeName =
          data.projecttype_name ||
          row.projecttype_name ||
          data.propertyPurpose ||
          "";
        const unitTypeName =
          data.projectunittype_name || row.projectunittype_name || "";

        return (
          <div className="py-0.5">
            <p className="text-sm font-bold leading-snug text-[#111827]">
              {typeName || "-"}
            </p>
            {unitTypeName ? (
              <p className="mt-0.5 text-sm leading-snug text-[#6B7280]">
                {unitTypeName}
              </p>
            ) : null}
          </div>
        );
      },
    },
    {
      headerName: "Property Status",
      field: "propertyStatus",
      minWidth: 180,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const row = params.row || {};
        const data = row.data || {};
        const statusName =
          data.projectstatus_name ||
          row.projectstatus_name ||
          data.propertyStatus ||
          "";

        return (
          <p className="text-sm leading-snug text-[#111827]">
            {statusName || "-"}
          </p>
        );
      },
    },
    {
      headerName: "Price",
      field: "price",
      minWidth: 150,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const row = params.row || {};
        const data = row.data || {};
        const label =
          row.price_label ||
          formatProjectPrice(data) ||
          formatProjectPrice(row) ||
          "Price On Request";
        return (
          <p className="text-sm font-semibold leading-snug text-[#111827]">
            {label}
          </p>
        );
      },
    },
    {
      headerName: "Furnished Type",
      field: "furnished_type",
      minWidth: 160,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const row = params.row || {};
        const data = row.data || {};
        const names =
          row.furnished_type_list ||
          getFurnishType(data.furnish_type || row.furnish_type);

        return (
          <div className="py-0.5">
            {(names || []).length ? (
              (names || []).map((name: string, idx: number) => (
                <p
                  key={`${name}-${idx}`}
                  className="text-sm font-semibold leading-snug text-[#111827]"
                >
                  {name}
                </p>
              ))
            ) : (
              <p className="text-sm leading-snug text-[#9CA3AF]">-</p>
            )}
          </div>
        );
      },
    },
    {
      headerName: "BHK",
      field: "BHK",
      minWidth: 140,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const row = params.row || {};
        const data = row.data || {};
        const label = row.bhk_label || getBHKLabel(data);
        return (
          <p className="text-sm font-semibold leading-snug text-[#111827]">
            {label || "-"}
          </p>
        );
      },
    },
    {
      headerName: "Bath",
      field: "bath",
      minWidth: 100,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const row = params.row || {};
        const data = row.data || {};
        const bath =
          data.bathroom ??
          row.bathroom ??
          data.washroom ??
          row.washroom ??
          "";
        return (
          <p className="text-sm leading-snug text-[#111827]">
            {bath === null || bath === undefined || bath === ""
              ? "-"
              : String(bath)}
          </p>
        );
      },
    },
    // {
    //   headerName: "Parking",
    //   field: "parking",
    //   minWidth: 221,
    //   flex: 1,
    //   renderCell: (params: YhTableCellParams) => (
    //     <Stack
    //       direction="column"
    //       justifyContent="flex-start"
    //       alignItems="flex-start"
    //       spacing={1}
    //     >
    //       {params.row.parking}
    //       <Typography sx={classes.subHeaderName}></Typography>
    //     </Stack>
    //   ),
    // },
    // {
    //   headerName: "Assign to",
    //   field: "assign_to",
    //   minWidth: 221,
    //   flex: 1,
    //   renderCell: (params: YhTableCellParams) => (
    //     <Stack
    //       direction="column"
    //       justifyContent="flex-start"
    //       alignItems="flex-start"
    //       spacing={1}
    //     >
    //       <Box sx={classes.assignButton}>

    //         <button className="assignBtn"
    //           onClick={() => {
    //             fetchAssignDetails(params.row.data);
    //             setOpenModal({
    //               name: "Stage Details",
    //               data: {
    //                 team: params.row?.data.AssignTo,
    //                 members: params.row?.data?.AssignToUser,
    //               },
    //               open: true,
    //             });
    //           }}
    //           data-action-button="true"
    //         >
    //           {" "}
    //           {params.row?.data?.AssignTo?.length}
    //           {/* {params.row.assign_to} */}
    //         </button>
    //       </Box>
    //     </Stack>
    //   ),
    // },
    {
      headerName: "Assigned To",
      field: "assign_to",
      minWidth: 160,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const data = params.row?.data || {};
        const teams = Array.isArray(data.AssignTo)
          ? data.AssignTo
          : Array.isArray(params.row?.AssignTo)
            ? params.row.AssignTo
            : [];
        const members = Array.isArray(data.AssignToUser)
          ? data.AssignToUser
          : Array.isArray(params.row?.AssignToUser)
            ? params.row.AssignToUser
            : [];
        const count = teams.length || members.length || 0;
        const shown = members.slice(0, 2);

        return (
          <button
            type="button"
            className="flex items-center gap-2 disabled:cursor-not-allowed disabled:opacity-50"
            onClick={() => {
              if (!count) return;
              setOpenModal({
                name: "Assigne-To",
                data: { team: teams, members },
                open: true,
              });
            }}
            data-action-button="true"
            disabled={!count}
          >
            <span className="flex h-7 min-w-[28px] items-center justify-center rounded-full bg-[#F9F0F4] px-1.5 text-xs font-bold text-[#A02448]">
              {count}
            </span>
            <span className="flex -space-x-2">
              {shown.map((m: any, i: number) => {
                const label =
                  m?.fullName || m?.name || m?.userName || m?.email || "?";
                const ch = String(label).charAt(0).toUpperCase();
                return (
                  <span
                    key={m?._id || m?.id || i}
                    className="flex h-7 w-7 items-center justify-center rounded-full border-2 border-white text-[10px] font-bold text-white"
                    style={{
                      backgroundColor: ["#A02448", "#14B8A6", "#F59E0B"][i % 3],
                    }}
                    title={label}
                  >
                    {ch}
                  </span>
                );
              })}
              {!shown.length && count > 0 ? (
                <span className="text-xs font-medium text-[#6B7280]">
                  {count} assigned
                </span>
              ) : null}
            </span>
          </button>
        );
      },
    },

    {
      headerName: "Status",
      field: "status",
      minWidth: 121,
      flex: 1,
      renderCell: (params: YhTableCellParams) => (
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={1}
        >
          <Typography sx={classes.subHeaderName}>
            <>
              {privileges &&
                (privileges?.["Project List"]?.includes("view") ||
                  privileges?.["Project List"]?.includes("full control")) ? (
                <Box>
                  <Switch
                    checked={
                      params.row.data.status === "1" ||
                      params.row.data.status === 1
                    }
                    onChange={(e) => {
                      const newStatus = e.target.checked ? "1" : "0";
                      changeStatus(newStatus, params.row.data._id);
                    }}
                    color="primary"
                  />
                </Box>
              ) : (
                ""
              )}
            </>
          </Typography>
        </Stack>
      ),
    },

    {
      headerName: "Project Id",
      field: "project_id_map",
      minWidth: 110,
      width: 110,
      renderCell: (params: YhTableCellParams) => (
        <button
          type="button"
          data-action-button="true"
          onClick={(e) => {
            e.stopPropagation();
            handelIdButton(
              params.row?.data?.status,
              params.row?.data?._id || params.row?._id
            );
          }}
          className="inline-flex h-8 min-w-[52px] items-center justify-center rounded-md border-2 border-[#A02448] bg-[#9CA3AF] px-3 text-xs font-bold text-white shadow-sm transition hover:bg-[#6B7280]"
        >
          ID
        </button>
      ),
    },

    {
      headerName: "Action",
      field: "Action",
      minWidth: 100,
      flex: 1,
      // renderCell: (params: YhTableCellParams) => (
      //   <Stack
      //     direction="column"
      //     justifyContent="center"
      //     alignItems="center"
      //     spacing={1}
      //   >
      //     <LongMenu
      //       idd={params.row.data._id}
      //       data={params.row.data}
      //       handleEdit={handleEdit}
      //       handelShare={() => {
      //         setOpen(true);
      //         setOpenView("share");
      //         setOpenUrl(params.row.data.property_broucher);
      //       }}
      //     />
      //   </Stack>
      // ),

      // new code 
      renderCell: (params: YhTableCellParams) => (
        <Box sx={classes.verticalDotButton}>
          <Button
            className="action-button"
            data-action-button="true"
            onClick={(event) => {
              event.stopPropagation();
              const rect = event.currentTarget.getBoundingClientRect();
              setMenuPosition({ top: rect.bottom, left: rect.left });
              setSelectedRow(params.row);
            }}
          >
            <VerticalDotIcon />
          </Button>
        </Box>
      ),
    },
  ];
  const getFurnishType = (value: any) => {
    try {
      const val = typeof value === "string" ? JSON.parse(value || "[]") : value || [];
      if (!Array.isArray(val)) return [];
      return val
        .filter((item: any) => item.status === 1)
        .map((item: any) => item.name);
    } catch {
      return [];
    }
  };

  const formatProjectPrice = (project: any = {}) => {
    const existing = project?.price;
    if (
      typeof existing === "string" &&
      existing.trim() &&
      isNaN(Number(existing.replace(/,/g, "")))
    ) {
      return existing.trim();
    }

    const fromList = (project?.priceList || [])
      .map((p: any) => {
        const raw = p?.price ?? p?.rawPrice;
        if (raw == null || raw === "") return null;
        const n = Number(String(raw).replace(/,/g, ""));
        return Number.isFinite(n) ? n : null;
      })
      .filter((n: number | null): n is number => n != null && n > 0);

    const numeric =
      Number(project?.minPrice) ||
      (fromList.length ? Math.min(...fromList) : 0) ||
      Number(String(existing || "").replace(/,/g, "")) ||
      0;

    if (!numeric || !Number.isFinite(numeric) || numeric <= 0) {
      return "Price On Request";
    }

    const country = String(
      project?.country_name || project?.country || ""
    ).toLowerCase();
    const currency = String(project?.currency || "").toUpperCase();
    const isAed =
      currency === "AED" ||
      country.includes("uae") ||
      country.includes("dubai") ||
      country.includes("emirates");

    if (isAed) {
      if (numeric >= 1000 && numeric < 1000000) {
        return `AED ${(numeric / 1000).toFixed(2)} K`;
      }
      return `AED ${Math.round(numeric)}`;
    }

    if (numeric >= 10000000) {
      return `₹ ${(numeric / 10000000).toFixed(2)} Cr`;
    }
    if (numeric >= 100000) {
      return `₹ ${(numeric / 100000).toFixed(2)} Lakh`;
    }
    return `₹ ${numeric.toLocaleString("en-IN")}`;
  };

  const getBHKLabel = (value: any = {}) => {
    try {
      const parseList = (raw: any) => {
        if (typeof raw === "string") return JSON.parse(raw || "[]");
        return Array.isArray(raw) ? raw : [];
      };
      const study = parseList(value.study);
      const utility = parseList(value.utility);
      const pooja = parseList(value.pooja);
      const studyVal = study.find((item: any) => item.status === 1)?.name;
      const utilityVal = utility.find((item: any) => item.status === 1)?.name;
      const poojaVal = pooja.find((item: any) => item.status === 1)?.name;

      const parts = [
        `${value.bedroom ? value.bedroom : ""} BHK`.trim(),
        studyVal === "Yes" ? "+ S" : "",
        utilityVal === "Yes" ? "+ U" : "",
        poojaVal === "Yes" ? "+ P" : "",
      ].filter(Boolean);

      return parts.join(" ").replace(/\s+/g, " ").trim();
    } catch {
      return value?.bedroom ? `${value.bedroom} BHK` : "BHK";
    }
  };

  const getBHK = (value: any) => {
    return <>{getBHKLabel(value)}</>;
  };
  const tableDataShowHandler = async () => {
    try {
      setApiResponse(true);
      setLoading(true)
      const payload = {
        pageNumber: paginationModel.page,
        pageSize: paginationModel.pageSize,
        search: debouncedSearch || "",
        status: "",
        propertyPurpose: "",
        organizationId:
          activeOrganizationId &&
          activeOrganizationId !== "all" &&
          activeOrganizationId !== "*"
            ? activeOrganizationId
            : "",
      };
      const response = await getProjectDetails(payload);
      // setMetaData(response.metadata)
      setMetaData(response?.metadata[0] ? response?.metadata[0] : metaData);
      let i = 1;
      let dt = [];
      if (props.type == "active") {
        dt = response.data.filter((e: any) => e.status == 1);
      } else if (props.type == "inactive") {
        dt = response.data.filter((e: any) => e.status == 0);
      } else {
        dt = response.data;
      }
      const source = dt.map((userData: any) => {
        return {
          sno: i++,
          _id: userData._id,
          project_name: userData.project_name,
          developer_name: userData.developer_name,
          project_uid: userData.project_uid,
          organizationId: userData.organizationId || "",
          projecttype_name: userData.projecttype_name,
          projectunittype_name: userData.projectunittype_name,
          projectstatus_name: userData.projectstatus_name,
          bathroom: userData.bathroom ?? userData.washroom,
          bhk_label: getBHKLabel(userData),
          AssignTo: userData.AssignTo || [],
          AssignToUser: userData.AssignToUser || [],
          location: (
            <>
              <Typography
                sx={classes.subHeaderName}
              >{`${userData?.city_name || (/^[a-f0-9]{24}$/i.test(String(userData?.city || "")) ? "" : userData?.city) || "—"}${userData?.state_name ? `, ${userData.state_name}` : ""}`}</Typography>
              <Typography sx={classes.subHeaderName}>
                {userData?.country_name}
              </Typography>
            </>
          ),
          propertyPurpose: (
            <>
              <Typography sx={classes.subHeaderName}>
                {userData?.propertyPurpose}
              </Typography>

            </>
          ),
          propertyStatus: (
            <>
              <Typography sx={classes.subHeaderName}>
                {userData?.propertyStatus}
              </Typography>
            </>
          ),
          price_label: formatProjectPrice(userData),
          minPrice: userData?.minPrice,
          price: (
            <>
              <Typography sx={classes.subHeaderName}>
                {formatProjectPrice(userData)}
              </Typography>
            </>
          ),
          furnished_type_list: getFurnishType(userData?.furnish_type),
          furnished_type: (
            <>
              <div style={{ textAlign: "center" }}>
                {getFurnishType(userData?.furnish_type)?.map((item: any) => {
                  return (
                    <Typography sx={classes.headerName}>
                      <div>{item}</div>
                    </Typography>
                  );
                })}
              </div>
            </>
          ),
          BHK: (
            <>
              <Typography sx={classes.headerName}>{getBHK(userData)}</Typography>
            </>
          ),
          bath: (
            <>
              <Typography sx={classes.headerName}>
                {userData?.bathroom}
              </Typography>
            </>
          ),
          parking: (
            <>
              <Typography sx={classes.headerName}>
                {userData?.car_parking}
              </Typography>
            </>
          ),
          // assign_to: (
          //   <>

          //     {JSON.parse(userData?.AssignTo || "[]").split(",")?.length}

          //   </>
          // ),
          status: (
            <>
              {privileges &&
                (privileges?.["Project List"]?.includes("view") ||
                  privileges?.["Project List"]?.includes("full control")) ? (
                <Box
                  sx={
                    userData.status == 0 ? classes.deActive : classes.activeBtn
                  }
                >
                  {/* <CustomButton
                    label={userData.status == 0 ? "Deactive" : "Active"}
                    buttonType="primaryBtn"
                    onClick={() => {
                      changeStatus(userData.status, userData._id);
                    }}
                  /> */}
                  {/* <Switch
  checked={userData.status === 1} // ON if active
  onChange={(e) => {
    const newStatus = e.target.checked ? 1 : 0; // true → 1, false → 0
    changeStatus(newStatus, userData._id);
  }}
  color="primary"
/> */}

                </Box>
              ) : (
                ""
              )}
            </>
          ),
          action: (
            <>
              <LongMenu
                idd={userData._id}
                data={userData}
                handleEdit={handleEdit}
              />
            </>
          ),
          data: userData,
        };
      });
      setUserDataSource([...source]);

      setApiResponse(false);
      setLoading(false)
    } catch (error: any) {
      setApiResponse(false);
      setLoading(false)
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handleCloseAddTeam = () => {
    setNewTeamDialog(false);
  };

  // Account status modal

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedUser({ ...selectedUser, status: +event.target.value });
  };

  const dialogHeaderContent = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
        <CloseIcon onClick={() => setIsDialogOpen(false)} />
      </Box>
    );
  };
  const handleWhatsAppShare = (shareLink: any) => {
    const whatsappUrl = `whatsapp://send?text=${encodeURIComponent(shareLink)}`;
    window.location.href = whatsappUrl;
  };

  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.content}>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={classes.pageHeading}>Account Status</Typography>
              <Typography sx={classes.pageSubHeading}>
                Change your account status
              </Typography>
            </Grid>

            <Grid item xs={12} mt={5}>
              <Typography sx={classes.statusHeading}>Current Status</Typography>

              <Box sx={classes.checkBoxWarapper}>
                <CustomRadioButton
                  value={1}
                  checked={selectedUser.status == 1}
                  onChange={handleRadioChange}
                  label="Active"
                />

                <CustomRadioButton
                  value={0}
                  checked={selectedUser.status == 0}
                  onChange={handleRadioChange}
                  label="Deactive"
                />
              </Box>

              <Box>
                <CustomButton
                  onClick={() => {
                    // handleDeleteAccount();
                  }}
                  label="Delete Account"
                  buttonType="iconBtn"
                  customClasses={{ color: "red" }}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box sx={classes.buttonWrapperDialog}>
                <CustomButton
                  label="Save"
                  onClick={() => { }}
                  buttonType="primaryBtn"
                />
                <CustomButton
                  label="Cancel"
                  onClick={() => {
                    setIsDialogOpen(false);
                  }}
                  buttonType="secondaryBtn"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };
  const handleRowOrderChange = async (params: any) => {
    const updatedRows = [...userDataSource];

    const [movedRow] = updatedRows.splice(params.oldIndex, 1);

    updatedRows.splice(params.targetIndex, 0, movedRow);

    const reorderedRows = updatedRows.map((row, index) => ({
      ...row,
      _id: row.data._id,
      sortOrder: index + 1,
      sno: index + 1
    }));

    setUserDataSource(reorderedRows);

    const payload = reorderedRows.map((row) => ({
      _id: row._id,
      sortOrder: row.sortOrder,
    }));

    try {
      await reorder({ project: payload });
    } catch (error) {
      console.error("Reorder failed", error);
    }
  };


  const getShowAllPage = () => {
    return (
      <>
        <Box sx={classes.showAllWrapper}>
          <Grid container>
            <Grid item xs={12}>
              <Grid container columnSpacing={5}>
                <Grid item xs={12} sx={customTableClasses.tableGridPart}>
                  <Box sx={{ mb: 2, maxWidth: 420 }}>
                    <YhInput
                      placeholder="Search"
                      type="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      autoFocus={isSearchFocused}
                      startAdornment={<SearchSvg />}
                      onFocus={() => setIsSearchFocused(true)}
                      onBlur={() => setIsSearchFocused(false)}
                    />
                  </Box>
                  {privileges &&
                    (privileges?.["Project List"]?.includes("view") ||
                      privileges?.["Project List"]?.includes("full control")) ? (
                    <>
                      <YhTable
                        columns={columns}
                        rows={userDataSource || []}
                        getRowId={(row) => row.sno}
                        rowHeight={95}
                        loading={apiResponse || loading}
                        emptyMessage="No projects found"
                        className="min-h-[320px]"
                        page={paginationModel.page}
                        pageSize={paginationModel.pageSize}
                        totalRows={metaData?.total || 0}
                        onPageChange={(p) =>
                          setPaginationModel((prev) => ({ ...prev, page: p }))
                        }
                        onPageSizeChange={(s) =>
                          setPaginationModel({ pageSize: s, page: 0 })
                        }
                      />
                      {renderMenu()}
                    </>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {apiResponse && <CustomLoader apiResponse={false} />}
        </Box>
        <CustomDialog
          fullScreen={true}
          isDialogOpen={isDialogOpen}
          dialogHeaderContent={dialogHeaderContent()}
          dialogTitleContent={dialogTitleContent()}
        />

        {isDialogOpenLoan && (
          <AddLoan
            isDialogOpenLoan={true}
            handleCloseLoan={handleCloseLoan}
            userId={userId}
            status={status}
          />
        )}
        <div>
          <Modal
            open={open && openView === "share"}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Share
              </Typography>
              <Box sx={{ mt: 2 }}>
                <IconButton
                  onClick={() => {
                    handleWhatsAppShare(openUrl || "");
                  }}
                  color="primary"
                >
                  <WhatsAppIcon />
                </IconButton>
              </Box>
            </Box>
          </Modal>

          <YhModal
            open={!!openModal?.open && openModal?.name === "Assigne-To"}
            onClose={() =>
              setOpenModal({ name: "", data: {}, open: false })
            }
            width={720}
            title={
              <div className="flex items-start gap-3 pr-2">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#F9F0F4] text-[#A02448]">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                  </svg>
                </span>
                <div className="min-w-0">
                  <div className="text-lg font-bold leading-tight text-[#1E1B4B]">
                    Team List
                  </div>
                  <p className="mt-0.5 text-sm font-normal text-[#6B7280]">
                    View teams and their members
                  </p>
                </div>
              </div>
            }
            footer={
              <button
                type="button"
                onClick={() =>
                  setOpenModal({ name: "", data: {}, open: false })
                }
                className="inline-flex h-10 min-w-[96px] items-center justify-center rounded-xl border border-[#E5E7EB] bg-white px-5 text-sm font-semibold text-[#374151] transition hover:bg-[#F8FAFC]"
              >
                Close
              </button>
            }
          >
            {(() => {
              const teams = openModal?.data?.team || [];
              const members = openModal?.data?.members || [];
              const teamIconColors = [
                { bg: "#F9F0F4", color: "#A02448" },
                { bg: "#DBEAFE", color: "#2563EB" },
                { bg: "#D1FAE5", color: "#059669" },
                { bg: "#FFEDD5", color: "#EA580C" },
              ];
              const memberPalette = [
                { bg: "#F9F0F4", color: "#6B1630" },
                { bg: "#DBEAFE", color: "#2563EB" },
                { bg: "#D1FAE5", color: "#059669" },
                { bg: "#FFEDD5", color: "#EA580C" },
                { bg: "#FCE7F3", color: "#DB2777" },
              ];

              const uniqueMembers = (() => {
                const seen = new Set<string>();
                return (Array.isArray(members) ? members : []).filter(
                  (m: any) => {
                    const id = String(m?._id ?? m?.id ?? m?.name ?? "").trim();
                    if (!id || seen.has(id)) return false;
                    seen.add(id);
                    return true;
                  }
                );
              })();

              const membersForTeam = (teamId: string, teamIndex: number) => {
                const tid = String(teamId ?? "");
                const matched = uniqueMembers.filter((member: any) => {
                  try {
                    const raw = member.team_id;
                    if (raw == null || raw === "" || raw === "NA") return false;
                    const teamIdArray =
                      typeof raw === "string" ? JSON.parse(raw) : raw;
                    return (
                      Array.isArray(teamIdArray) &&
                      teamIdArray.some((id: any) => String(id) === tid)
                    );
                  } catch {
                    return false;
                  }
                });
                if (matched.length > 0) return matched;
                if (teams.length === 1) return uniqueMembers;
                const anyLinked = uniqueMembers.some(
                  (m: any) => m?.team_id && m.team_id !== "NA"
                );
                if (!anyLinked && teamIndex === 0) return uniqueMembers;
                return matched;
              };

              const totalMembers = uniqueMembers.length;

              return (
                <div className="space-y-4">
                  <div className="flex flex-wrap items-center gap-8 rounded-2xl border border-[#F9F0F4] bg-gradient-to-r from-[#F5F3FF] to-[#F9F0F4] px-5 py-4">
                    <div className="flex items-center gap-2.5">
                      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-[#A02448] shadow-sm">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                          <circle cx="9" cy="7" r="4" />
                          <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                        </svg>
                      </span>
                      <div>
                        <p className="text-xs font-medium text-[#6B7280]">
                          Total Teams
                        </p>
                        <p className="text-base font-bold text-[#1E1B4B]">
                          {teams.length}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2.5">
                      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-[#A02448] shadow-sm">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                          <circle cx="12" cy="7" r="4" />
                        </svg>
                      </span>
                      <div>
                        <p className="text-xs font-medium text-[#6B7280]">
                          Total Members
                        </p>
                        <p className="text-base font-bold text-[#1E1B4B]">
                          {totalMembers}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="max-h-[340px] overflow-auto rounded-xl border border-[#EEF0F5]">
                    <div className="sticky top-0 z-[1] grid grid-cols-[1fr_1.4fr_24px] gap-3 border-b border-[#EEF0F5] bg-[#F8FAFC] px-4 py-3">
                      <span className="text-[11px] font-bold uppercase tracking-wide text-[#6B7280]">
                        Team Name
                      </span>
                      <span className="text-[11px] font-bold uppercase tracking-wide text-[#6B7280]">
                        Team Members
                      </span>
                      <span />
                    </div>

                    {teams.length === 0 ? (
                      <div className="px-4 py-8 text-center text-sm text-[#9CA3AF]">
                        No teams found
                      </div>
                    ) : (
                      teams.map((item: any, index: number) => {
                        const teamMembers = membersForTeam(
                          item._id || item.id,
                          index
                        );
                        const icon =
                          teamIconColors[index % teamIconColors.length];
                        return (
                          <div
                            key={item._id || item.id || index}
                            className="grid grid-cols-[1fr_1.4fr_24px] items-center gap-3 border-t border-[#EEF0F5] px-4 py-3.5"
                          >
                            <div className="flex min-w-0 items-start gap-2.5">
                              <span
                                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl"
                                style={{
                                  backgroundColor: icon.bg,
                                  color: icon.color,
                                }}
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                >
                                  <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                                  <circle cx="9" cy="7" r="4" />
                                  <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                                </svg>
                              </span>
                              <div className="min-w-0">
                                <p className="truncate text-sm font-bold text-[#111827]">
                                  {item.team_name || item.label || "—"}
                                </p>
                                <span className="mt-1 inline-flex rounded-full bg-[#F9F0F4] px-2 py-0.5 text-[11px] font-semibold text-[#A02448]">
                                  {teamMembers.length} Member
                                  {teamMembers.length === 1 ? "" : "s"}
                                </span>
                              </div>
                            </div>

                            <div className="flex min-w-0 flex-col gap-2">
                              {teamMembers.length === 0 ? (
                                <span className="text-xs text-[#9CA3AF]">
                                  No members
                                </span>
                              ) : (
                                teamMembers.map((member: any, idx: number) => {
                                  const name = member.name || member.label || "—";
                                  const initials =
                                    String(name)
                                      .split(" ")
                                      .filter(Boolean)
                                      .slice(0, 2)
                                      .map((p: string) => p[0]?.toUpperCase())
                                      .join("") || "?";
                                  const avatar =
                                    memberPalette[idx % memberPalette.length];
                                  return (
                                    <div
                                      key={member._id || member.id || idx}
                                      className="flex min-w-0 items-center gap-2"
                                    >
                                      <span
                                        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[10px] font-bold"
                                        style={{
                                          backgroundColor: avatar.bg,
                                          color: avatar.color,
                                        }}
                                      >
                                        {initials}
                                      </span>
                                      <span className="truncate text-sm font-semibold text-[#111827]">
                                        {name}
                                      </span>
                                    </div>
                                  );
                                })
                              )}
                            </div>

                            <span className="flex justify-end text-[#9CA3AF]">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                              >
                                <path d="M9 18l6-6-6-6" />
                              </svg>
                            </span>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              );
            })()}
          </YhModal>
        </div>

        <YhModal
          open={!!projectPopUp.open}
          onClose={handleProjectIdClose}
          width={520}
          title="Map Project ID"
          footer={
            <div className="flex justify-end gap-2">
              <YhButton
                variant="secondary"
                size="sm"
                onClick={handleProjectIdClose}
              >
                Cancel
              </YhButton>
            </div>
          }
        >
          <MapProjectIdBody
            data={projectPopUp.data}
            project_id={projectPopUp.project_id}
            handelIdButtonSave={handelIdButtonSave}
          />
        </YhModal>
        <UpdatePricingModal
          open={Boolean(pricingTarget?.id)}
          projectId={pricingTarget?.id || ""}
          projectName={pricingTarget?.name}
          onClose={() => setPricingTarget(null)}
          onSaved={() => tableDataShowHandler()}
        />
      </>
    );
  };

  return getShowAllPage();
};

const PROJECT_ID_TYPE_OPTIONS = [
  { label: "HC", value: "HC" },
  { label: "AC", value: "AC" },
  { label: "FC", value: "FC" },
  { label: "GL", value: "GL" },
  { label: "YC", value: "YC" },
];

const MapProjectIdBody = (props: {
  data?: any[];
  project_id?: any;
  handelIdButtonSave: (data: any) => void;
}) => {
  const [form, setForm] = useState<{ type?: string; uid?: string }>({});
  const [saving, setSaving] = useState(false);

  const onSubmit = async () => {
    if (!form.type) {
      openErrorNotification("Please select project type");
      return;
    }
    if (!form.uid?.trim()) {
      openErrorNotification("Please enter project ID");
      return;
    }
    try {
      setSaving(true);
      await props.handelIdButtonSave({
        ...form,
        project_id: props.project_id,
      });
    } finally {
      setSaving(false);
    }
  };

  const formatDate = (value: any) => {
    if (!value) return "-";
    try {
      return new Date(value).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return String(value);
    }
  };

  return (
    <div className="space-y-5">
      <div className="space-y-3">
        <YhSelect
          label="Select Type"
          placeholder="select your Project Type"
          showOptionIcon={false}
          value={form.type || ""}
          options={PROJECT_ID_TYPE_OPTIONS}
          onChange={(e) =>
            setForm((prev) => ({ ...prev, type: String(e.target.value) }))
          }
        />
        <YhInput
          label="Project ID"
          placeholder="Enter project ID"
          value={form.uid || ""}
          onChange={(e) =>
            setForm((prev) => ({ ...prev, uid: e.target.value }))
          }
        />
        <YhButton
          variant="primary"
          fullWidth
          disabled={saving}
          onClick={onSubmit}
        >
          {saving ? "Submitting..." : "Submit"}
        </YhButton>
      </div>

      <div>
        <h3 className="mb-3 text-sm font-bold text-[#111827]">All Other Data</h3>
        <div className="overflow-hidden rounded-xl border border-[#EEF0F5]">
          <table className="w-full border-collapse text-left">
            <thead className="bg-[#F8FAFC]">
              <tr>
                <th className="px-3 py-2.5 text-[11px] font-bold uppercase tracking-wide text-[#6B7280]">
                  Type
                </th>
                <th className="px-3 py-2.5 text-[11px] font-bold uppercase tracking-wide text-[#6B7280]">
                  Uid
                </th>
                <th className="px-3 py-2.5 text-right text-[11px] font-bold uppercase tracking-wide text-[#6B7280]">
                  Created At
                </th>
              </tr>
            </thead>
            <tbody>
              {(props.data || []).length === 0 ? (
                <tr>
                  <td
                    colSpan={3}
                    className="px-3 py-6 text-center text-sm text-[#9CA3AF]"
                  >
                    No mapped IDs yet
                  </td>
                </tr>
              ) : (
                (props.data || []).map((item: any, index: number) => (
                  <tr
                    key={item?._id || index}
                    className="border-t border-[#EEF0F5]"
                  >
                    <td className="px-3 py-2.5 text-sm font-medium text-[#111827]">
                      {item?.type || "-"}
                    </td>
                    <td className="px-3 py-2.5 text-sm text-[#374151]">
                      {item?.uid || "-"}
                    </td>
                    <td className="px-3 py-2.5 text-right text-sm text-[#6B7280]">
                      {formatDate(item?.createdAt)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ShowAll;
